function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.00032 2.9988C6.00032 1.53007 4.80499 0.333252 3.33366 0.333252C1.86454 0.333252 0.666992 1.53007 0.666992 2.9988C0.666992 4.46976 1.86454 5.66658 3.33366 5.66658C4.80499 5.66658 6.00032 4.46976 6.00032 2.9988Z",
  fill: "#3558C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.3333 2.9988C15.3333 1.53007 14.138 0.333252 12.6667 0.333252C11.1975 0.333252 10 1.53007 10 2.9988C10 4.46976 11.1975 5.66658 12.6667 5.66658C14.138 5.66658 15.3333 4.46976 15.3333 2.9988Z",
  fill: "#3558C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.6668 2.9988C24.6668 1.53007 23.4715 0.333252 22.0002 0.333252C20.531 0.333252 19.3335 1.53007 19.3335 2.9988C19.3335 4.46976 20.531 5.66658 22.0002 5.66658C23.4715 5.66658 24.6668 4.46976 24.6668 2.9988Z",
  fill: "#3558C7"
}));

function SvgOptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 6,
    viewBox: "0 0 25 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.244ed1b8.svg";
export { ForwardRef as ReactComponent };